import React, { useState } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

// import { login, getCurrentUser } from "../../services/auth.service";

import Footer from '../Footer/Footer';

import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../../contexts/AuthContext';
import './Login.css';

type Props = {};

const Login: React.FC<Props> = () => {
	const [email, setEmail] = useState<string>('');
	const [passwd, setPasswd] = useState<string>('');
	const { login, customLogin, user } = useAuth();

	let navigate: NavigateFunction = useNavigate();

	const handleGoogleSuccess = async (credentialResponse: any) => {
		try {
			await login(credentialResponse.credential);
		} catch (error) {
			console.error('Login failed:', error);
		}
	};

	const handleGoogleError = () => {
		console.error('Google login failed');
	};

	const handleBasicAuth = async () => {
		try {
			await customLogin(email, passwd);
		} catch (error) {
			console.error('Login failed:', error);
		}
	};

	return (
		<div>
			<div className='account-pages pt-2 pt-sm-5 pb-4 pb-sm-5'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-xxl-4 col-lg-5'>
							<div className='card'>
								{/* Logo */}
								<div className='card-header py-4 text-center bg-primary'>
									<a href='#'>
										<span>
											<img src='assets/images/TAHMOLOGO.png' alt='logo' width='200px' height='auto' />
										</span>
									</a>
								</div>
								<div className='card-body p-4'>
									<div className='text-center w-75 m-auto'>
										<h4 className='text-dark-50 text-center pb-0 fw-bold'>Sign In</h4>
										<p className='text-muted mb-4'>
											Log in with your Google account to proceed. Please note that you can create a Google account on any existing email address, it doesn't necessarily have to
											be a Gmail account.
										</p>
									</div>
									<GoogleLogin
										onSuccess={handleGoogleSuccess}
										onError={() => {
											console.log('Login Failed');
										}}
										useOneTap
									/>
									{process.env.REACT_APP_ENVIRONMENT === 'local' && (
										<>
											<hr />
											<form>
												<div className='mb-3'>
													<label htmlFor='email' className='form-label'>
														Email
													</label>
													<input type='email' id='email' className='form-control' onChange={(e) => setEmail(e.target.value)} />
												</div>
												<div className='mb-3'>
													<label htmlFor='passwd' className='form-label'>
														Password
													</label>
													<input type='password' id='passwd' className='form-control' onChange={(e) => setPasswd(e.target.value)} />
												</div>
												<button type='button' className='btn btn-primary' onClick={handleBasicAuth}>
													Submit
												</button>
											</form>
										</>
									)}
								</div>{' '}
								{/* end card-body */}
							</div>
							{/* end card */}
						</div>{' '}
						{/* end col */}
					</div>
					{/* end row */}
				</div>
				{/* end container */}
			</div>
			<Footer />
		</div>
	);
};

export default Login;
